module.exports = __webpack_public_path__ + "img/bl.e1ed2f23.svg";